import { Component, inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../../services/auth.service";
import { NotificationService } from "../../services/notification.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { passwordValidator } from "../../shared/validators/input-validators";
import { DarkModeService } from "../../services/dark-mode.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: false
})

export class ChangePasswordComponent implements OnInit {
  form: FormGroup;
  loading = false;
  // password
  showPassword: boolean = true;
  showPassword2: boolean = true;
  showPassword3: boolean = true
  token: string;
  private readonly fb: FormBuilder = inject(FormBuilder)
  private readonly authService: AuthService = inject(AuthService)
  private readonly notificationService: NotificationService = inject(NotificationService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly router: Router = inject(Router);
  private readonly location: Location = inject(Location)
  private readonly darkModeService: DarkModeService = inject(DarkModeService);

  // Dark Mode State
  public activeLightMode: 'light' | 'night' = 'light';
  public isLightMode: boolean = true;

  constructor() {
  }

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.paramMap.get("token")
    this.form = this.fb.group({
      newPassword: [null, [Validators.required, Validators.pattern(passwordValidator)]],
      confirmPassword: [null, Validators.required],
      oldPassword: [null, Validators.required],
    });

    // Initialize dark mode state
    this.activeLightMode = this.darkModeService.isDarkMode ? 'night' : 'light';
    this.isLightMode = this.activeLightMode === 'light';
  }

  submitForm(value) {
    // // console.log(value)
    if (value.newPassword === value.confirmPassword) {
      let data = {
        newPassword: value.newPassword,
        oldPassword: value.oldPassword,
      }
      this.authService.changePassword(data).then(
        async () => {
          await this.authService.logout();
        }
      )
    } else {
      this.notificationService.errorMessage("New Password and Confirm Password do not match");
    }
  }

  goBack() {
    this.location.back();
  }

  /**
   * Toggles between light and dark theme
   */
  public toggleTheme(): void {
    this.activeLightMode = this.isLightMode ? 'light' : 'night';
    this.darkModeService.toggleDarkMode();
  }
}
